import {FC} from 'react';
import Text from '@atoms/Text';
import {theme} from '@styles/theme';
import {StatusLabelWrapper} from '@atoms/StatusLabel.styles';

export interface TooltipProps {
  text: string;
  type?: 'green' | 'red' | 'yellow';
}

const StatusLabel: FC<TooltipProps> = ({text, type = 'green'}) => {
  return (
    <StatusLabelWrapper type={type}>
      <Text
        text={text}
        type="tinyM"
        color={
          type == 'red'
            ? theme.colors.signalRed00
            : type == 'yellow'
              ? theme.colors.signalOrange00
              : theme.colors.signalGreen00
        }
      />
    </StatusLabelWrapper>
  );
};

export default StatusLabel;
